import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, TransitionGroup as _TransitionGroup, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  id: "portfolio",
  class: "portfolio-section"
}
const _hoisted_2 = { class: "section-title" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "about" }
const _hoisted_5 = { class: "title" }
const _hoisted_6 = { class: "text" }
const _hoisted_7 = { class: "tecnology" }
const _hoisted_8 = { class: "links" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["href"]
const _hoisted_11 = { class: "name" }
const _hoisted_12 = ["src", "alt"]

import { ref } from 'vue';
import VueEasyLightbox from 'vue-easy-lightbox';
import { useLocalized } from '@/composables/useLocalized';
import { projects } from '@/data/projects';


export default /*@__PURE__*/_defineComponent({
  __name: 'PortfolioSection',
  setup(__props) {

const { pick } = useLocalized();
const visibleProjects = projects;

const visible = ref(false);
const imgs = ref<string[]>([]);
const index = ref(0);

function showGallery(images: string[]) {
  imgs.value = images;
  index.value = 0;
  visible.value = true;
}

function handleHide() {
  visible.value = false;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_unref(VueEasyLightbox), {
      visible: visible.value,
      imgs: imgs.value,
      index: index.value,
      onHide: handleHide
    }, null, 8, ["visible", "imgs", "index"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.$t('sections.portfolio')), 1)
    ]),
    _createVNode(_TransitionGroup, {
      name: "projects",
      tag: "div",
      class: "projects"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(visibleProjects), (project) => {
          return (_openBlock(), _createElementBlock("article", {
            key: project.id,
            class: "project"
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h3", _hoisted_5, _toDisplayString(_unref(pick)(project.i18n).title), 1),
              _createElementVNode("p", _hoisted_6, _toDisplayString(_unref(pick)(project.i18n).text), 1),
              _createElementVNode("p", _hoisted_7, _toDisplayString(_unref(pick)(project.i18n).technology), 1),
              _cache[0] || (_cache[0] = _createElementVNode("div", { class: "sep" }, null, -1)),
              _createElementVNode("div", _hoisted_8, [
                (project.images?.length)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      href: "#",
                      onClick: _withModifiers(($event: any) => (showGallery(project.images)), ["prevent"])
                    }, _toDisplayString(_ctx.$t('portfolio.seeMore')), 9, _hoisted_9))
                  : _createCommentVNode("", true),
                (project.link)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 1,
                      href: project.link,
                      target: "_blank",
                      rel: "noopener noreferrer"
                    }, _toDisplayString(_ctx.$t('portfolio.open')), 9, _hoisted_10))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("p", _hoisted_11, _toDisplayString(_unref(pick)(project.i18n).title), 1),
            _createElementVNode("img", {
              src: project.image,
              alt: _unref(pick)(project.i18n).title,
              loading: "lazy"
            }, null, 8, _hoisted_12)
          ]))
        }), 128))
      ]),
      _: 1
    })
  ]))
}
}

})